import Vue from "vue";

const getDefaultState = () => {
    return {
    };
};

const Downloadables = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {},
    actions: {
        fetch: ({commit, rootState}) => {
            return Vue.prototype.$apiService.get(`accounts/${rootState.User.account.id}/downloadables/premiere-pro-extension`)
        },
    },
    getters: {},
};

export default Downloadables;
